export const ENDPOINTS = {
    // Iris Integration Endpoints
    GET_APPROVALS: `api/iris/getApprovals`,

    // Lead Management Endpoints
    GET_ZOHO_LEADS: `api/leads`,
    POST_ZOHO_LEADS_NEW_LEAD: `api/leads/newlead`,
    SEARCH_COMBINED: `api/leads/search-combined`,
    EXPORT_LEADS: `api/leads/export`,
    UPDATE_LEAD_NOTES: `api/leads/update-notes`,
    GET_USER_INFO: `api/user`,
    GET_LEAD_INFO: `api/report/sendZoho`,
    UPDATE_ZOHO_LEAD: `api/report/updateLead`,
    UPDATE_BUSINESS_INFO: `api/businessInfo/updateBusinessInfo`,
    
    // Company Management Endpoints
    GET_ALL_COMPANIES: `api/companies`,
    CREATE_COMPANY: `api/companies`,
    
    // User Management Endpoints
    GET_ALL_USERS: `api/user/all`,
    GET_FILTER_OPTIONS: `api/user/filters`,
    GET_USERS_BY_COMPANY: (companyName) => `api/user/company/${encodeURIComponent(companyName)}`,
    CREATE_USER: `api/user/create`,
    UPDATE_USER: (id) => `api/user/${id}`,
    UPDATE_USER_STATUS: `api/user/status`,
    UPDATE_USER_ROLE: `api/user/role`,
    RESET_USER_PASSWORD: `api/user/reset-password`,
    DELETE_USER: (id) => `api/user/${id}`,
    
    // Role & Permission Management Endpoints
    GET_ALL_ROLES: `api/roles`,
    GET_ROLE_BY_ID: (id) => `api/roles/${id}`,
    CREATE_ROLE: `api/roles`,
    UPDATE_ROLE: (id) => `api/roles/${id}`,
    REORDER_ROLES: `api/roles/reorder`,
    
    // Rate Review Endpoints
    SUBMIT_RATE_REVIEW: `api/rate-review`,
    GET_RATE_REVIEW_LEADS: `api/rate-review/list`,
    SEARCH_RATE_REVIEW_COMBINED: `api/rate-review/search-combined`,
    UPDATE_RATE_REVIEW_LEAD: (zohoId) => `api/rate-review/${zohoId}`,
    GET_RATE_REVIEW_BY_TOKEN: (zohoId) => `api/rate-review/public/${zohoId}`,
    GET_LEAD_ATTACHMENTS: (zohoId) => `api/rate-review/${zohoId}/attachments`,
    VIEW_ATTACHMENT: (zohoId, attachmentId) => `api/rate-review/${zohoId}/attachments/${attachmentId}/view`,
    
    // Zoom Scheduler
    GET_ZOOM_SCHEDULER_URL: `api/zoom/scheduler-url`,
    GET_ZOOM_ADMIN_CONFIG: `api/zoom/admin-config`,
    UPDATE_ZOOM_ADMIN_CONFIG: `api/zoom/admin-config`,
    
    // Round Robin Configuration Endpoints
    GET_ROUND_ROBIN_CONFIG: `api/zoom/round-robin-config`,
    UPDATE_ROUND_ROBIN_CONFIG: `api/zoom/round-robin-config`,
};
